import { AppState, AppStateActionParams } from 'records/AppState';

export interface FocusedMarkupActions {
  setFocusedMarkup: (
    ActionParams: AppStateActionParams,
    markupID: string
  ) => Promise<AppState>;

  clearFocusedMarkup: (ActionParams: AppStateActionParams) => Promise<AppState>;
}

const focusedMarkupActions = {
  setFocusedMarkup: async (
    { state }: AppStateActionParams,
    markupID: string
  ): Promise<AppState> => {
    return state().set('focusedMarkup', markupID);
  },

  clearFocusedMarkup: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    return state().set('focusedMarkup', '');
  },
};

export default focusedMarkupActions;
